// extracted by css-extract-rspack-plugin
export default {"srOnly":"_H7AN","unstyled":"zaW2q"};